import { makeVar } from "@apollo/client";
import type { RefObject } from "react";
import type { DmmServiceItem } from "~/components/blocks/layout/global-navi/type";

type InitialState = {
  /** mini末端の表示条件、全画面から参照するフラグ */
  shouldShowPreviewModal: boolean;
  /** hover可能な端末かを判定するフラグ, mini末端でタッチデバイスかマウスデバイスかを判定する時に利用する */
  isAvailableHover: boolean;
  /** DMMのサービス一覧 */
  dmmServiceListData: DmmServiceItem[];
  /** 値下げ通知表示済みフラグ */
  isNotifiedPriceDown: boolean;
  footerRef: RefObject<HTMLDivElement>;
};

export const initialState: InitialState = {
  shouldShowPreviewModal: false,
  isAvailableHover: false,
  dmmServiceListData: [],
  isNotifiedPriceDown: false,
  footerRef: {
    current: null,
  },
};

export const shouldShowPreviewModalVar = makeVar(initialState.shouldShowPreviewModal);
export const isAvailableHoverVar = makeVar(initialState.isAvailableHover);
export const dmmServiceListDataVar = makeVar(initialState.dmmServiceListData);
export const footerRefVar = makeVar(initialState.footerRef);
